<template>
  <div id="app">
    <el-container>
      <SidebarComponent v-if="adminStore.isLoggedIn" />
      <el-container direction="vertical">
        <HeaderComponent v-if="adminStore.isLoggedIn" />
        <div class="main-content">
          <router-view />
        </div>
      </el-container>
    </el-container>
  </div>
</template>

<script setup>
import { useAdminStore } from "@/stores/admin";
import SidebarComponent from '@/components/SidebarComponent.vue';
import HeaderComponent from '@/components/HeaderComponent.vue';

const adminStore = useAdminStore();

</script>

<style scoped>
#app {
  display: flex;
  width: 100%;
  overflow: hidden;
}

.main-content {
  flex: 1;
  padding: 20px;
}
</style>
